function requireAll(r) {
	r.keys().forEach(r);
}

requireAll(require.context('./ico/', true));
requireAll(require.context('./svg/', true, /\.svg$/));
requireAll(require.context('./fonts/', true));
requireAll(require.context('./admin-thumbs/', true, /\.png$/));
//requireAll( require.context( './png/', true, /\.png$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );

import $ from 'jquery';

import Swiper from 'swiper';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { gsap, Circ, Linear } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import tabsList from '../../../../../vendor/tabsspaces/tabslist/src/assets/tabsList.js';

gsap.registerPlugin( ScrollTrigger );

window.jQuery = $;
window.$ = $;

ScrollTrigger.normalizeScroll({

	type: "touch"

});

$(function() {
	var PROJECT = {

		common: {
			
			getViewport: function() {
				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {
					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;
				} else if (
					typeof document.documentElement !== 'undefined' &&
					typeof document.documentElement.clientWidth !== 'undefined' &&
					document.documentElement.clientWidth !== 0
				) {
					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;
				} else {
					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width: viewPortWidth, height: viewPortHeight };
			},

			init: function() {

				PROJECT.nav.init();

				PROJECT.toggle.init();

				PROJECT.accordion.init();

				PROJECT.gform.init();

				PROJECT.list.init();

				PROJECT.titleUnderline.init();

				PROJECT.cardDivider.init();

				PROJECT.swiper.init();

				PROJECT.animation.init();

				PROJECT.sidemenu.init();

				window.tabsList.init();

			},
		},

		toggle: {
			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {
				$(document).on('click', PROJECT.toggle.clickElm, PROJECT.toggle.switch);
			},

			switch: function(e) {
				let $elm = $(this);

				let $label = $elm.find(PROJECT.toggle.labelElm);

				let toggleText = $elm.data(PROJECT.toggle.dataAttr);

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text(newText);

				$elm.attr('title', newText);
			},
		},

		nav: {
			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */

			mainElm: '.navMain',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-header--nav-open',

			init: function() {
				$(document).on('click', PROJECT.nav.clickElm, PROJECT.nav.toggle);

				$(document).on('keyup', PROJECT.nav.esc);

				$(PROJECT.nav.mainElm + ' a').each(function() {
					$(this).attr('tabindex', -1);
				});
			},

			toggle: function() {
				if ($('html').hasClass(PROJECT.nav.openClass)) {
					PROJECT.nav.close();
				} else {
					PROJECT.nav.open();
				}
			},

			esc: function(e) {
				if (e.keyCode === 27) {
					PROJECT.nav.close();
				}
			},

			open: function() {
				$('html').addClass(PROJECT.nav.openClass);

				$(PROJECT.nav.mainElm + ' a').each(function() {
					$(this).removeAttr('tabindex', -1);
				});
			},

			close: function() {
				$('html').removeClass(PROJECT.nav.openClass);

				$(PROJECT.nav.mainElm + ' a').each(function() {
					$(this).attr('tabindex', -1);
				});
			},
		},

		accordion:{

			init: function() {

				$( document ).off( 'click', '.jsAccordionTrigger');
				$( document ).on( 'click', '.jsAccordionTrigger', {

					class: 'jsAccordion--open',
					classElement: '.jsAccordion',
					toggleElement: '.jsAccordionTarget',

				}, PROJECT.accordion.toggle );

			},

			toggle: function ( e ) {

				e.preventDefault();

				var parent = $( this ).closest( e.data.classElement );

				if ( !$( parent ).hasClass( e.data.class ) ) {

					$( '.' + e.data.class ).find( '.jsAccordionTrigger' ).trigger( 'click' );

					$( parent ).addClass( e.data.class );

					if ( e.data.toggleElement !== '' ) {

						$( parent ).find( e.data.toggleElement ).stop().slideDown( 250 ).css({
							display: "flex"
						  });

					}

				} else {

					$( parent ).removeClass( e.data.class );

					if ( e.data.toggleElement !== '' ) {

						$( parent ).find( e.data.toggleElement ).stop().slideUp( 250 ).css({
							display: "flex"
						  });

					}

				}

			},

		},

		gform: {

			init: function() {

				$(document).on('gform_post_render', PROJECT.gform.hideLoader);

				$(document).on('click.loader', '.gform_button', PROJECT.gform.showLoader);
				$(document).on('click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader);
				$(document).on('submit', '.gform_wrapper form', PROJECT.gform.showLoader);

				$(document).on('gform_page_loaded', PROJECT.gform.hideLoader);

				$(document).on('gform_confirmation_loaded', PROJECT.gform.showConfirmation);
				$(document).on('click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation);

				$(document).on('focus', 'input, textarea, select', function() {
					$(this)
						.parents('.gfield')
						.addClass('state--has-focus');
				});

				$(document).on('blur', 'input, textarea, select', function(e) {
					if (!$(this).val()) {
						$(this)
							.parents('.gfield')
							.removeClass('state--has-focus');
					}
				});

				PROJECT.gform.fixHasFocus();
			},

			fixHasFocus: function() {
				$('input, textarea, select').each(function() {
					if ($(this).val()) {
						$(this)
							.parents('.gfield')
							.addClass('state--has-focus');
					}
				});
			},

			showLoader: function() {
				var $gformContainer = $(this).closest('.gformContainer');
				var $gformLoader = $gformContainer.find('.gformLoader');

				$gformLoader.fadeIn(300).css('display', 'flex');
			},

			hideLoader: function() {
				
				$('.gformLoader').fadeOut(300);

				PROJECT.gform.fixHasFocus();
			},

			showConfirmation: function() {
				$('.gformConfirmation')
					.fadeIn(300)
					.css('display', 'flex');
			},

			hideConfirmation: function() {
				$('.gformConfirmation').fadeOut(300);
			},
		},

		list: {
			// Only for project based code.
			init: function() {},
		},

		titleUnderline: {

			init: function() {

				PROJECT.titleUnderline.calculate();

				let resizeTimer;

				$(window).on('resize', function() {

					clearTimeout(resizeTimer);

					resizeTimer = setTimeout(PROJECT.titleUnderline.calculate, 250);

				});

			},

			calculate: function() {

				$('.jsAtomTitle').each(function() {

					let $el = $(this);
					let range = document.createRange();
					range.selectNodeContents(this);
					let rects = range.getClientRects();

					if (rects.length > 0) {

						let lastRect = rects[rects.length - 1];
						$el.css('--underline-width', lastRect.width + 'px');

					}

				});

			},

		},

		cardDivider: {

			init: function() {

				PROJECT.cardDivider.calculate();

				let resizeTimer;

				$(window).on('resize', function() {

					clearTimeout(resizeTimer);

					resizeTimer = setTimeout(PROJECT.cardDivider.calculate, 250);

				});

			},

			calculate: function() {

				$('.jsViewCardTeamMember').each(function() {

					let $card = $(this);
					let $title = $card.find('.v-card-team-member__title');

					if ($title.length > 0) {

						let range = document.createRange();
						range.selectNodeContents($title[0]);
						let rects = range.getClientRects();

						if (rects.length > 0) {

							let lastRect = rects[rects.length - 1];
							$card.css('--divider-width', lastRect.width + 'px');

						}

					}

				});

			},

		},
		
		swiper: {

			init: function () {

				PROJECT.swiper.teamSelectionCarousel();

				PROJECT.swiper.teamCarousel();

			},

			teamSelectionCarousel: function () {

				let carouselsSections = document.querySelectorAll( '.jsSectionTeamSelection' );

				if ( carouselsSections.length > 0 ) {

					carouselsSections.forEach( function( carouselsSection ) {

						const carouselEl = carouselsSection.querySelector( '.jsTeamSelectionCarousel' );

						let swiperInstance = null;

						if ( carouselEl ) {

							const breakpoint = 996;

							function initSwiper() {
								if ( window.innerWidth < breakpoint && !swiperInstance ) {
									swiperInstance = new Swiper( carouselEl, {
										
										spaceBetween: 0,

										slidesPerView: 1.25,

									} );
								}
							}

							function destroySwiper() {
								if ( window.innerWidth > breakpoint && swiperInstance ) {
									swiperInstance.destroy( true, true );
									swiperInstance = null;
								}
							}

							function handleResize() {
								if ( window.innerWidth > breakpoint ) {
									destroySwiper();
								} else {
									initSwiper();
								}
							}

							initSwiper();

							window.addEventListener( 'resize', handleResize );

						}
						
					});
				}

			},

			teamCarousel: function () {

				document.querySelectorAll( '.jsSectionTeam' ).forEach( function( section ) {

					const carouselEl = section.querySelector( '.jsTeamCarousel' );

					if ( !carouselEl ) {

						return;

					}

					const breakpoint = 996;
					const disableMobile = section.dataset.disableMobileSlider === '1';
					const disableDesktop = section.dataset.disableDesktopSlider === '1';
					const prevEl = section.querySelector( '.jsTeamCarouselPrev' );
					const nextEl = section.querySelector( '.jsTeamCarouselNext' );

					let splideInstance = null;

					function shouldUseSlider() {

						return window.innerWidth >= breakpoint ? !disableDesktop : !disableMobile;

					}

					function getPeek() {

						// Matches calc-vw-xs(40) / calc-vw-md(160)
						return window.innerWidth < breakpoint
							? ( 40 / 375 ) * window.innerWidth
							: ( 160 / 1920 ) * window.innerWidth;

					}

					function clearInlineStyles() {

						carouselEl.removeAttribute( 'style' );
						carouselEl.classList.remove( 'is-initialized', 'is-active', 'is-rendered' );

						carouselEl.querySelectorAll( '.splide__track, .splide__list, .splide__slide' ).forEach( function( el ) {

							el.removeAttribute( 'style' );

						} );

					}

					function initSplide() {

						if ( splideInstance || !shouldUseSlider() ) {

							return;

						}

						const peek = getPeek();
						const options = {

							type: 'loop',
							gap: 0,
							arrows: false,
							pagination: false,
							mediaQuery: 'min',
							perPage: 1,
							perMove: 1,
							drag: 'free',
							snap: true,
							padding: { left: peek, right: peek },
							autoScroll: {
								speed: 0.8,
								pauseOnHover: true,
								pauseOnFocus: true,
							},

						};

						if ( !disableDesktop ) {

							options.breakpoints = {

								[ breakpoint ]: {

									perPage: 5,
									perMove: 1,

								}

							};

						}

						splideInstance = new Splide( carouselEl, options ).mount( { AutoScroll } );
						PROJECT.cardDivider.calculate();

					}

					function destroySplide() {

						if ( !splideInstance ) {

							return;

						}

						splideInstance.destroy( true );
						splideInstance = null;
						clearInlineStyles();
						PROJECT.cardDivider.calculate();

					}

					function onResize() {

						if ( shouldUseSlider() ) {

							if ( !splideInstance ) {

								initSplide();

							} else {

								const peek = getPeek();

								splideInstance.options = { padding: { left: peek, right: peek } };
								splideInstance.refresh();

							}

						} else {

							destroySplide();

						}

					}

					if ( prevEl ) {

						prevEl.addEventListener( 'click', function() {

							if ( splideInstance ) {

								splideInstance.go( '-1' );

							}

						} );

					}

					if ( nextEl ) {

						nextEl.addEventListener( 'click', function() {

							if ( splideInstance ) {

								splideInstance.go( '+1' );

							}

						} );

					}

					initSplide();
					window.addEventListener( 'resize', onResize );

				} );

			},
		},

		animation: {

			headerTop: 0,

			init: function() {

				// scrollTrigger animations

				PROJECT.animation.getHeaderHeight();
				PROJECT.animation.initScrollTrigger();

				window.addEventListener( 'resize', () => {

					var allTriggers = ScrollTrigger.getAll();

					if ( allTriggers.length > 0 ) {

						allTriggers.forEach( ( trigger ) => {

							trigger.kill( true );

						});

					}

					PROJECT.animation.getHeaderHeight();

					PROJECT.animation.initScrollTrigger();

				});

			},

			getHeaderHeight: function() {

				let header = document.getElementById( 'header' );

				PROJECT.animation.headerTop = header.offsetHeight;

			},

			initScrollTrigger: function() {

				const mediaQuery = window.matchMedia( '(min-width: 996px)' );

				if ( mediaQuery.matches ) {
					
					PROJECT.animation.initScrollTriggerDesktop();

				} else {

					PROJECT.animation.initScrollTriggerMobile();

				}

			},

			initScrollTriggerMobile: function() {

				PROJECT.animation.headerNavAnim();

			},

			initScrollTriggerDesktop: function() {

				PROJECT.animation.paralaxAnim();
				PROJECT.animation.headerNavAnim();

			},

			paralaxAnim: function() {

				let paralaxSections = document.querySelectorAll( ".jsParalax" );

				if ( paralaxSections !== null ) {

					paralaxSections.forEach( ( paralaxSection, index) => {

						let paralaxImg = paralaxSection.querySelector(".jsParalaxImg");

						gsap.timeline({

							scrollTrigger: {

								trigger: paralaxSection,
								start: "top bottom",
								end: "bottom top",
								scrub: true,
								//markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20 },

							}

						}).fromTo( paralaxImg, {

							y: "-30vw",
							ease: "none"

						}, {

							y: "30vw",
							ease: "none"

						});

					});

				};

			},

			headerNavAnim: function() {

				let firstBreakoutSection = document.querySelector( ".s-breakout-box:first-child" );

				if ( firstBreakoutSection !== null ) {

					let headerTransition = document.getElementById( 'jsHeaderTransition' );

					// change header color

					gsap.timeline({

						scrollTrigger: {

							trigger: firstBreakoutSection,
							start: "top " + PROJECT.animation.headerTop,
							end: PROJECT.animation.headerTop + " " + PROJECT.animation.headerTop,
							scrub: true,
							//markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20 },

						}

					}).fromTo( headerTransition, {

						y: "100%",
						ease: "none"

					}, {

						y: "0%",
						ease: "none"

					});
					
					// fix content in breakout box

					let breakoutContent = firstBreakoutSection.querySelector( ".jsBreakoutContent" );

					gsap.timeline({

						scrollTrigger: {

							trigger: firstBreakoutSection,
							start: "top " + PROJECT.animation.headerTop,
							end: "bottom " + PROJECT.animation.headerTop,
							scrub: true,
							//markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20 },

						}

					}).fromTo( breakoutContent, {

						y: "0%",
						ease: "none"

					}, {

						y: "100%",
						ease: "none"

					});

					let home = document.querySelector( '.home' );

					if ( home !== null ) {

						let headerLogo = document.getElementById( 'jsHeaderLogo' );

						// show small logo

						gsap.timeline({

							scrollTrigger: {

								trigger: firstBreakoutSection,
								start: "top " + PROJECT.animation.headerTop,
								end: PROJECT.animation.headerTop + " " + PROJECT.animation.headerTop,
								scrub: true,
								//markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20 },

							}

						}).fromTo( headerLogo, {

							height: "0%",
							ease: "none"

						}, {

							height: "100%",
							ease: "none"

						});

						let pageLogo = document.getElementById( 'jsPageLogo' );

						gsap.timeline({

							scrollTrigger: {

								trigger: firstBreakoutSection,
								start: "top " + PROJECT.animation.headerTop,
								end: PROJECT.animation.headerTop + " " + PROJECT.animation.headerTop,
								scrub: true,
								//markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20 },

							}

						}).fromTo( pageLogo, {

							height: "100%",
							ease: "none"

						}, {

							height: "0%",
							ease: "none"

						});

					} 

				};

			},

		},
	
		sidemenu: {

			init: function() {

				let sideMenu = document.querySelector( ".jsSidemenu" );

				if ( sideMenu !== null ) {

					PROJECT.sidemenu.initHeight();
					
					window.addEventListener( 'resize', () => {

						PROJECT.sidemenu.initHeight();

					});

				}

			},

			initHeight: function() {

				const mediaQuery = window.matchMedia( '(min-width: 996px)' );

				if ( mediaQuery.matches ) {
					
					PROJECT.sidemenu.setHeight();

				} else {

					PROJECT.sidemenu.unsetHeight();

				}

			},

			setHeight: function() {

				let sideMenu = document.querySelector( ".jsSidemenu" );

				let breakoutContent = document.querySelector( ".jsBreakoutHeight" );

				breakoutContent.style.minHeight = sideMenu.offsetHeight + 'px';

			},

			unsetHeight: function() {

				let breakoutContent = document.querySelector( ".jsBreakoutHeight" );

				breakoutContent.style.minHeight = 'unset';

			}

		}

	};

	var UTIL = {
		exec: function(controller, action) {
			var ns = PROJECT;
			action = action === undefined ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {
				ns[controller][action]();
			}
		},

		init: function() {
			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);
		},
	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);
});
